import { render } from "./dictionaryEditModal.vue?vue&type=template&id=4b6f20a2&ts=true"
import script from "./dictionaryEditModal.vue?vue&type=script&lang=ts"
export * from "./dictionaryEditModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__